import { render, staticRenderFns } from "./OfficerDetailsModal.vue?vue&type=template&id=78fef797&scoped=true"
import script from "./OfficerDetailsModal.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OfficerDetailsModal.vue?vue&type=style&index=0&id=78fef797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fef797",
  null
  
)

export default component.exports